import { Dispatch } from "../../config/controller";
import { Sala } from "../../config/data.types";
import { Model,StateProps } from "../../config/model";

export type { Sala } from "../../config/data.types";

export interface SalaState extends StateProps<Sala> {
 
}

export interface SalaActions extends Dispatch<Sala> {

}

const model = new Model<Sala,SalaState>("sala");

export const initialValueSala:Sala = {
    ...model.getInitialValue(),
    type:"sala",
    descricao:""
}

export const initialValueSalaState:SalaState = {
    ...model.getInititalValueState(),
    row:initialValueSala,   
}


